import { get } from 'lodash';

type Store = {
  runtimeConfig: {
    config?: {
      mapByDisableUnreadMessages?: {}
    }
  },
  account: {
    currentAccount?: {
      id: number
    }
  }
};

export function isDisableUnreadMessagesSelector(
  {
    runtimeConfig,
    account
  }: Store
) {
  return get(runtimeConfig, `config.mapByDisableUnreadMessages.${account.currentAccount ? account.currentAccount.id : 0}`) || false;
}
